export default {
  methods: {
    exportReport(url, query, fileName) {
      this.processed = false;
      this.loader = true;
      this.showexportMsg = true;
      let name = query.reportType === "Pdf" ? fileName + ".pdf" : fileName + ".csv";

      if (!query.exportLinkOnly) {
        if (query.exportType === 0) {
          name = fileName + ".pdf";
        } else if (query.exportType === 1) {
          name = fileName + ".zip";
        }
      } else {
        name = fileName + ".csv";
      }

      this.$http
        .post(url, query, { responseType: "arraybuffer" })
        .then((resp) => {
          let contentTypeValues =
            resp.headers &&
            resp.headers.map &&
            resp.headers.map["content-type"];

          let contentType = "";
          if (contentTypeValues && contentTypeValues.length > 0) {
            contentType = contentTypeValues[0];
          }

          let blob = new Blob([resp.data], {
            type: contentType
          });

          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);

          if (query.preview) {
            this.previewUrl = link.href;
          } else {
            link.download = name;
            link.click();
            this.dialog = false;
          }

          this.loader = false;
          this.showexportMsg = false;
        }).catch((failure) => {
          this.handleFailure(failure);
        });
    },
    handleFailure(failure) {
      let msg = failure.body.message || "Error";
      let errors = failure.body.errors;
      if (errors && errors.SelfOrderClient) {
        msg = errors.SelfOrderClient;
      }
      this.$store.commit("showSnackbar", {
        message: msg,
        color: "error"
      });
    }
  }
};